"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _jsxRuntime = require("react/jsx-runtime");

var NoCurrentVersion = function NoCurrentVersion(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("em", {
    className: "information",
    children: [props.children ? props.children : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
      value: "document.documentDetails.noPresentDocument"
    }), props.onExampleClick && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: ", "
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: "/",
        onClick: props.onExampleClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.documentDetails.documentExample"
        })
      })]
    })]
  });
};

NoCurrentVersion.propTypes = {
  // If provided, will show the example link
  onExampleClick: _propTypes.default.func,
  // If NOT provided, a default text will be displayed
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.func])
};
var _default = NoCurrentVersion;
exports.default = _default;
//# sourceMappingURL=NoCurrentVersion.js.map